import React from "react";
import { Box, Checkbox, FormControlLabel, IconButton, InputAdornment, MenuItem } from "@mui/material";
import RadioButton from "../components/RadioButton";
import SelectWrapper from "../components/Select";
import SelectDistrictWrapper from "../components/Select/DistrictSelect";
import SelectNotifiedAreaWrapper from "../components/Select/NotifiedAreaSelect";
import TextInput from "../components/TextInput";
import UploadButton from "../components/UploadButton";
import DatePick from "../components/DatePick";
import TimePick from "../components/TimePick";
import { Search } from "@mui/icons-material";
import { Controller } from "react-hook-form";

const InputContainer = ({
  label,
  width,
  height,
  disabled = false,
  selectSuffix = null,
  hasLabel = true,
  mandatory,
  name,
  control,
  placeholder,
  type,
  data,
  mobileNumber,
  select,
  defaultValue,
  multiColumn,
  multiLine = false,
  uploadValidity,
  labelWidth,
  clickControl,
  getDocumentData,
  containerStyles,
  containerClasses,
  getIndex,
  getArea,
  validation,
  maxLength,
  showSearchIcon,
  onSearchClick,
  autoWidth,
  isRequired,
}) => {
  console.log("fromInputcontainer", validation, name);

  return (
    <div className={`inputContainer ${containerClasses}`} style={containerStyles}>
      {hasLabel && type !== "defaultCheckbox" && (
        <h3 className={`label ${multiColumn ? "multiCoumn" : ""}`} style={{ width: labelWidth && labelWidth }}>
          {label}
          {mandatory && <span className="compulsoryField"> *</span>}
        </h3>
      )}
      {type === "textInput" ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1vw",
            width: width || "18.25vw",
          }}
        >
          {selectSuffix && (
            <SelectWrapper
              //control={selectSuffix.control}
              variant="outlined"
              width="6vw"
              size="small"
              {...selectSuffix}
              defaultValue={selectSuffix?.defaultValue}
              validation={validation}
            />
          )}
          <TextInput
            // label={placeholder || label}
            // label={placeholder || label}
            placeholder={placeholder}
            variant="outlined"
            size="small"
            disabled={disabled}
            width={width || (selectSuffix ? "11.25vw" : "18.25vw")}
            height={height}
            name={name}
            select={select}
            control={control}
            defaultValue={defaultValue}
            multiline={multiLine}
            isRequired={isRequired}
            InputProps={{
              style: { borderRadius: "1px" },
              ...(mobileNumber && {
                startAdornment: <InputAdornment position="start">+91</InputAdornment>,
              }),
              endAdornment: showSearchIcon && ( // Conditionally render search icon
                <InputAdornment position="end">
                  <IconButton onClick={onSearchClick}>
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            validation={validation}
            inputProps={{ maxLength }}
          >
            {!selectSuffix &&
              data &&
              select &&
              data?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
          </TextInput>
        </Box>
      ) : type === "radioButton" ? (
        <RadioButton
          defaultValue={defaultValue}
          clickControl={clickControl}
          control={control}
          width={width}
          data={data}
          name={name}
          row
          validation={validation}
          disabled={disabled}
        />
      ) : type === "selectInput" ? (
        <SelectWrapper
          control={control}
          placeholder={placeholder}
          defaultValue={defaultValue}
          inputLabel={placeholder}
          width={width}
          label={label}
          data={data}
          name={name}
          autoWidth={autoWidth}
          disabled={disabled}
          validation={validation}
          isRequired={isRequired}
          InputProps={{
            style: { borderRadius: "1px" },
          }}
        />
      ) : type === "upload" ? (
        <UploadButton error={uploadValidity} />
      ) : type === "htmlUpload" ? (
        <div className="uploadHtml">
          <input type="file" name={name} onChange={(e) => getDocumentData(e?.target?.files[0], name)} />
          <h6 className="error">{uploadValidity}</h6>
        </div>
      ) : type === "datePicker" ? (
        <DatePick
          placeholder={placeholder}
          control={control}
          // label={label}
          name={name}
          width={width}
          validation={validation}
        />
      ) : type === "timePicker" ? (
        <TimePick control={control} label={label} name={name} />
      ) : type === "number" ? (
        <TextInput
          // label={placeholder || label}
          // label={placeholder || label}
          placeholder={placeholder}
          variant="outlined"
          size="small"
          type="number"
          disabled={disabled}
          width={width || "18.25vw"}
          height={height}
          name={name}
          control={control}
          defaultValue={defaultValue}
          inputProps={{
            step: "any",
            min: 0,
            max: { maxLength },
          }}
          InputProps={{
            style: { borderRadius: "1px" },
          }}
        />
      ) : type === "checkbox" ? (
        <FormControlLabel
          control={
            <Controller
              name={name}
              control={control}
              defaultValue={defaultValue}
              render={({ field: { onChange, value } }) => (
                <Checkbox
                  checked={value} // Control the checked state
                  onChange={(e) => {
                    onChange(e.target.checked); // Update form state
                  }}
                  disabled={disabled}
                />
              )}
            />
          }
          label={label}
        />
      ) : type === "defaultCheckbox" ? (
        <FormControlLabel
          control={
            <Checkbox
              name={name}
              checked={defaultValue} // Control the checked state
              // onChange={(e) => {
              //   // Handle change to update form state
              //   control.setValue(name, e.target.checked);
              // }}
              disabled={disabled}
            />
          }
          label={label}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default InputContainer;
